import React, { useState, useEffect } from "react";
import "./Footer.css";

import ContactForm from "../ContactForm/ContactForm";

import ftrLogo from "../../assets/imgs/logo.png";
import qr from "../../assets/imgs/qr.png";
import qr2 from "../../assets/imgs/qr2.png";

export default function Footer() {
  const [showForm, setShowForm] = useState(false);
const currentYear = new Date().getFullYear();

  useEffect(() => {
    document.body.style.overflow = showForm ? "hidden" : "auto";
  }, [showForm]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      setShowForm(false);
    }
  };

  return (
    <>
      <div className="ftr" id="contact">
        <div className="maxW">
          <div className="ftrMn">
            <a href="/" className="ftrLWrp">
              <img src={ftrLogo} alt="logo" />
            </a>

            <div className="ftrCont">
              <h2>Contact</h2>
              <h3>Interested? Get More Information</h3>

              <p className="ftrTxt">
                Please Contact Us For The Site Visit, Booking Enquiry And Discounts,
                Layouts, Price And Payment Plan Or Any Query Related To
                Arvind Plots Vadodara
              </p>

              <div className="ftrBtns">
                <a href="tel:9710933555" className="btn callBtn">
                  Make a Call
                </a>

                <button
                  type="button"
                  className="btn enqBtn"
                  onClick={() => setShowForm(true)}
                >
                  Send an Enquiry
                </button>
              </div>

              <div className="qrWraps">
                <div className="qriWrp">
                  <img src={qr} alt="Agent RERA QR" />
                  <div className="qhdWrp">
                    <h6>Agent RERA</h6>
                    <span>#........</span>
                  </div>
                </div>

                <div className="qriWrp">
                  <img src={qr2} alt="Project RERA QR" />
                  <div className="qhdWrp">
                    <h6>Project RERA</h6>
                    <span>#RAA00217/A1R/230818</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ftrLine"></div>

        <p className="cpyTxt">
      All Rights Reserved © {currentYear} <span>Arvind Plots Vadodara</span> Developed by{" "}
      <a href="https://www.cfcs.co.in/">CFCS</a>
    </p>
      </div>


      {showForm && (
        <button
          type="button"
          className="popupOverlay"
          aria-label="Close enquiry form"
          onClick={handleOverlayClick}
        >
          <div className="FtrpupForm">
            <ContactForm />

            <button
              type="button"
              className="closeBtn"
              aria-label="Close popup"
              onClick={() => setShowForm(false)}
            >
              ✕
            </button>
          </div>
        </button>
      )}
    </>
  );
}
